import { Container } from 'flux/utils';
import ActivityActions from 'payments/actions/ActivityActions';
import ActivityDetail from 'payments/components/ActivityDetail.jsx';
import ActivityStore from 'payments/stores/ActivityStore';
import React, { Component, PropTypes } from 'react';

class ActivityDetailContainer extends Component {
  static propTypes = {
    activityId: PropTypes.string.isRequired,
  }

  static getStores() {
    return [ActivityStore];
  }

  static calculateState(_, props) {
    return {
      activity: ActivityStore.getActivityById(props.activityId),
    };
  }

  componentDidMount() {
    // always refresh activities, cause we dont have any push event.
    ActivityActions.loadByUuid(this.props.activityId);
  }

  render() {
    if (!this.state.activity) {
      return null;
    }

    return (
      <ActivityDetail activity={this.state.activity} />
    );
  }
}

export default Container.create(ActivityDetailContainer, { withProps: true });



// WEBPACK FOOTER //
// ./src/payments/containers/ActivityDetailContainer.jsx